import { FC, ReactNode } from 'react';
import { Box, Stack, Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';
import Text from '../text';

interface Props {
  title: string;
  headerActions?: ReactNode;
  bold?: boolean;
}

const useStyles = createUseStyles((theme: Theme) => ({
  sectionHeader: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

const SectionHeader: FC<Props> = ({ title, headerActions, bold = true }) => {
  const styles = useStyles();
  return (
    <Box className={styles.sectionHeader} pb={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
        <Text bold={bold} size="large" color="active">
          {title}
        </Text>
        {headerActions}
      </Stack>
    </Box>
  );
};

export default SectionHeader;
